import { Stack } from "@mui/material";
import { useFormik } from "formik";

import { useAvaCaseIQContext } from "./AvaCaseIQProvider";
import { AvaCreateTicket } from "./AvaCreateTicket";
import { AvaCreateTicketFooter } from "./AvaCreateTicketFooter";
import { CaseIQSuccess } from "./CaseIQSuccess";
import { useCreateCaseIQTicket, useInitializeCaseIQFields } from "./createTicketHook";
import { DoitLoading } from "./DoitLoading";
import { type CaseIQFormikValues } from "./types";

export const AvaCaseIQ = ({ bigWidth }: { bigWidth: boolean }) => {
  const { onSubmit, submitted, isSubmitting, concedefyEmail } = useCreateCaseIQTicket();

  const { caseIQConversationId } = useAvaCaseIQContext();

  const formik = useFormik<CaseIQFormikValues>({
    initialValues: {
      platform: "",
      cloudProduct: null,
      asset: null,
      priority: "",
      content: "",
      requester: "",
      callMe: false,
    },
    onSubmit,
  });

  const { loading, initialTechnicalDetails } = useInitializeCaseIQFields(formik.setValues, caseIQConversationId);

  if (loading) {
    return <DoitLoading />;
  }

  return (
    <Stack
      sx={{
        backgroundColor: "general.backgroundDark",
        justifyContent: "space-between",
        overflow: "auto",
        flex: 1,
      }}
    >
      {submitted ? (
        <CaseIQSuccess concedefyEmail={concedefyEmail} ticketValues={formik.values} />
      ) : (
        <AvaCreateTicket bigWidth={bigWidth} formik={formik} initialTechnicalDetails={initialTechnicalDetails} />
      )}

      <AvaCreateTicketFooter
        bigWidth={bigWidth}
        caseIQValues={formik.values}
        onSubmit={formik.handleSubmit}
        isSubmitting={isSubmitting}
        submitted={submitted}
      />
    </Stack>
  );
};
